module.exports = __webpack_public_path__ + "img/munic-escobar.153684e4.png";